module.exports = __webpack_public_path__ + "media/components/assets/img/bg/branding-4e61ef850e0e97229d6913d6e0290cf0.svg";